import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import s from './Toast.module.css';

const Ctx = createContext<(msg: string) => void>(() => {});
export function useToast() { return useContext(Ctx); }

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<{ id: number; msg: string }[]>([]);
  const push = useCallback((msg: string) => {
    const id = Date.now() + Math.random();
    setItems(x => [...x, { id, msg }]);
    setTimeout(() => setItems(x => x.filter(i => i.id !== id)), 3200);
  }, []);
  return (
    <Ctx.Provider value={push}>
      {children}
      <div className={s.wrap} aria-live="polite">{items.map(i => <div key={i.id} className={s.toast}>✓ {i.msg}</div>)}</div>
    </Ctx.Provider>
  );
}
